import firebaseEmail from './firebaseEmail';

function userFromAuth(user) {
  const auth = { ...user, ...user.providerData[0] };
  // providerData[0] may carry a null email that would hide the account's own email
  return { auth, email: firebaseEmail(user), photoURL: auth.photoURL };
}

export default userFromAuth;
